import React from 'react';

const Alabama = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Alabama Specific Terms
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>
          Buyer is responsible for discovering home defects; no specific
          disclosure form required.
        </li>
        <li>
          Disclosure Requirements: Sellers must disclose defects that could
          affect the property's value.
        </li>
        <li>
          Attorney Involvement: Attorney involvement is common for closing.
        </li>
        <li>
          Buyer Beware: Alabama is a “buyer beware” or “caveat emptor” state
          which means that the buyer agrees to take possession of the property
          on an “as-is” basis. There are no guarantees made by the seller.
        </li>
        <li>
          Known Defects: If the buyer asks a specific question about the
          property, the seller has an “obligation to disclose known facts.”
        </li>
        <li>
          <span className="underline"> Lead-Based Paint Disclosure</span> – Only
          for residences that were built before 1978. This information should be
          available at the County’s Revenue Office.
        </li>
        <li>
          <span className="underline">
            Seller's Property Disclosure Statement
          </span>{' '}
          – Not required but recommended to inform the buyer of any pertinent
          information about the property.
        </li>
      </ol>
    </div>
  );
};

export default Alabama;
